/* @flow */

import { compose } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';
import { connect } from 'react-redux';
import { getEventName } from '@e180/domain/lib/event/util';

import ModerationAcceptedAndSlackNotificationDumb from './ModerationAcceptedAndSlackNotificationDumb';
import { getSlackChannelName } from 'plugin/slack/util/slackUtils';
import { dismissNotification } from 'src/shared/app/notification/action/uiNotificationActions';
import { getEventSafely } from 'src/shared/domain/event/selector/eventSelectors';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';
import type { State } from 'src/shared/core/type/reduxTypes';

type Props = {
  notification: Notification,
  // Self passed
  // $FlowIssue
  intl: intlShape,
};

const mapStateToProps = (
  state: State,
  { notification, intl }: Props,
): Object => {
  const event = getEventSafely(state);

  return {
    eventName: getEventName(event, intl.locale),
    slackChannelName: getSlackChannelName(event),
    notification,
  };
};

const mapDispatchToProps = (
  dispatch: any,
  { notification }: Props,
): Object => ({
  handleDismiss() {
    dispatch(dismissNotification(notification));
  },
});

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(ModerationAcceptedAndSlackNotificationDumb);
